import { FunctionComponent, MouseEventHandler } from "react"
import { useRouter } from "next/router"
import Link from "next/link"
import cn from "classnames"

import { useSteps } from "@/hooks/useSteps"

import DoneIcon from "@/assets/icons/done.svg"

import styles from "./styles.module.scss"

interface Step {
  route: string
}

interface FormStepProps {
  currentStep: number
}

const FormStepper: FunctionComponent<FormStepProps> = ({ currentStep }) => {
  const { steps, query } = useSteps()

  return (
    <div className={styles.stepper__wrapper}>
      <div className={styles.stepper}>
        {steps.map(({ route }, index) => (
          <Step
            key={index}
            isActive={index + 1 < currentStep}
            link={`${route}?${query}`}
          />
        ))}
      </div>
    </div>
  )
}

const Step: FunctionComponent<{
  isActive: boolean
  link: string
  onClick?: MouseEventHandler<HTMLAnchorElement>
}> = ({ isActive, link, onClick }) => {
  const className = cn(
    styles.stepper__item,
    isActive && styles["stepper__item--done"]
  )
  return isActive ? (
    <Link href={link} className={className} onClick={onClick}>
      {isActive && <DoneIcon />}
    </Link>
  ) : (
    <div className={className} />
  )
}

export default FormStepper
